var styles = {"customizablePanel":"save-custom-panel-button--customizable-panel","saveButton":"save-custom-panel-button--save-button","multiTestSaveButton":"save-custom-panel-button--multi-test-save-button"};

export { styles as default };
//# sourceMappingURL=SaveCustomPanelButton.module.esm.js.map
